import {CircularProgress} from "@mui/material";

export default function SystemKnowledgeExamplePictureLoader() {
    // Used through the app to display one single screen centered
    // circular loader

    // BUILD
    return (
        <div className={'animate-appear w-full flex justify-center items-center mt-[12px]'}>
            <CircularProgress size={"32px"}
                              style={{'color' : '#DBE2EC'}} />
        </div>
    );
}